import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdExtension,
  MdLogout,
  MdAttachMoney,
  MdNotifications,
  MdPeople,
  MdHandyman,
  MdSmartToy,
} from 'react-icons/md';
import { HiOutlineChat } from 'react-icons/hi';
import { IoIosBusiness } from 'react-icons/io';
import { HiDocumentReport, HiOutlineUsers } from 'react-icons/hi';
import { FaWpforms } from 'react-icons/fa';
import { BiTransfer } from 'react-icons/bi';
import UserReports from './views/admin/default/main';
import Integrations from './views/admin/integrations/Integrations';
import DataTables from 'views/admin/dataTables/DataTables';
import Sales from 'views/admin/sales/Sales';
import Employees from './views/company/employees/Employees';

import SignIn from './views/auth/signIn/SignIn';
import OTP from './views/auth/otp/OTP';
import CompanySignupWizard from './views/auth/companySignup/CompanySignupWizard';
import Companies from './views/admin/companies/Companies';
import Users from './views/admin/users/Users';
import Messaging from './views/admin/messaging/Messaging';
import Applications from './views/admin/applications/Applications';
import AdminReports from './views/admin/reports/AdminReports';
import Reports from './views/company/reports/Reports';
import Transfers from './views/company/transfers/Transfers';
import Notifications from './views/admin/notifications/Notifications';

import FormsTable from './views/company/forms/FormsTable';
import JobReferrals from './views/admin/jobReferrals/JobReferrals';
import Tools from './views/admin/tools/Tools';
import AIAssistant from './views/admin/ai/AIAssistant';

import User from './api/user';
import MockApi from './api/mockApi';

/**
 * Checks if a route is accessible to the current user based on their screens permissions
 * @param {string} path - The route path to check (e.g. '/rtl-default')
 * @returns {boolean} - True if the user has access to the route, false otherwise
 */
const isRouteAccessible = (path) => {
  const routePath = path.split('/').pop();
  const userInfo = User.GetInfo();

  if (!userInfo) return false;

  // In case the screens do not exist on the user - the defaults are added by User.GetInfo
  const hasScreens = userInfo && userInfo.screens && Array.isArray(userInfo.screens);

  if (hasScreens) {
    const hasAccess = userInfo.screens.includes(routePath);
    return hasAccess;
  }
  return false;
};

const routes = [
  {
    name: 'ראשי',
    layout: '/rtl',
    path: '/rtl-default',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: UserReports,
    accessible: () => isRouteAccessible('/rtl-default'),
  },
  {
    name: 'איתן AI',
    layout: '/rtl',
    icon: <Icon as={MdSmartToy} width="20px" height="20px" color="inherit" />,
    path: '/ai-assistant',
    component: AIAssistant,
    accessible: () => isRouteAccessible('/ai-assistant'),
  },
  {
    name: 'התראות',
    layout: '/rtl',
    path: '/notifications',
    icon: <Icon as={MdNotifications} width="20px" height="20px" color="inherit" />,
    component: Notifications,
    accessible: () => isRouteAccessible('/notifications'),
  },
  {
    name: 'חברות',
    layout: '/rtl',
    path: '/companies',
    icon: <Icon as={IoIosBusiness} width="20px" height="20px" color="inherit" />,
    component: Companies,
    accessible: () => isRouteAccessible('/companies'),
  },
  {
    name: 'עובדים',
    layout: '/rtl',
    path: '/users',
    icon: <Icon as={HiOutlineUsers} width="20px" height="20px" color="inherit" />,
    component: Users,
    accessible: () => isRouteAccessible('/users'),
  },
  {
    name: 'הודעות',
    layout: '/rtl',
    path: '/messaging',
    icon: <Icon as={HiOutlineChat} width="20px" height="20px" color="inherit" />,
    component: Messaging,
    accessible: () => isRouteAccessible('/messaging'),
  },

  {
    name: 'עובדים',
    layout: '/rtl',
    path: '/employees',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: Employees,
    accessible: () => isRouteAccessible('/employees'),
  },
  {
    name: 'העברות',
    layout: '/rtl',
    path: '/applications',
    icon: <Icon as={BiTransfer} width="20px" height="20px" color="inherit" />,
    component: Applications,
    accessible: () => isRouteAccessible('/applications'),
  },
  {
    name: 'העברות',
    layout: '/rtl',
    path: '/transfers',
    icon: <Icon as={BiTransfer} width="20px" height="20px" color="inherit" />,
    component: Transfers,
    accessible: () => isRouteAccessible('/transfers'),
  },
  {
    name: 'טפסים',
    layout: '/rtl',
    path: '/forms',
    icon: <Icon as={FaWpforms} width="20px" height="20px" color="inherit" />,
    component: FormsTable,
    accessible: () => isRouteAccessible('/forms'),
  },
  {
    name: 'דוחות',
    layout: '/rtl',
    path: '/reports',
    icon: <Icon as={HiDocumentReport} width="20px" height="20px" color="inherit" />,
    component: AdminReports,
    accessible: () => isRouteAccessible('/reports'),
  },
  {
    name: 'דוחות',
    layout: '/rtl',
    path: '/reports-1',
    icon: <Icon as={HiDocumentReport} width="20px" height="20px" color="inherit" />,
    component: Reports,
    accessible: () => isRouteAccessible('/reports-1'),
  },
  {
    name: 'אינטגרציות',
    layout: '/rtl',
    path: '/integrations',
    icon: <Icon as={MdExtension} width="20px" height="20px" color="inherit" />,
    component: Integrations,
    accessible: () => MockApi.IsActive,
  },
  {
    name: 'כלים',
    layout: '/rtl',
    icon: <Icon as={MdHandyman} width="20px" height="20px" color="inherit" />,
    path: '/tools',
    component: Tools,
    accessible: () => isRouteAccessible('/tools'),
  },
  {
    name: 'נתונים',
    layout: '/rtl',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    path: '/data-tables',
    component: DataTables,
    accessible: () => isRouteAccessible('/data-tables'),
  },
  {
    name: 'הפניות',
    layout: '/rtl',
    path: '/job-referrals',
    icon: <Icon as={MdPeople} width="20px" height="20px" color="inherit" />,
    component: JobReferrals,
    accessible: () => isRouteAccessible('/job-referrals'),
  },
  {
    name: 'מכירות',
    layout: '/rtl',
    icon: <Icon as={MdAttachMoney} width="20px" height="20px" color="inherit" />,
    path: '/sales',
    component: Sales,
    accessible: () => isRouteAccessible('/sales'),
  },

  {
    name: 'Signin',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdHome} width="16px" height="16px" color="inherit" />,
    component: SignIn,
    hide: true,
    accessible: () => true, // Always accessible
  },
  {
    name: 'Otp',
    layout: '/auth',
    path: '/otp',
    icon: <Icon as={MdHome} width="16px" height="16px" color="inherit" />,
    component: OTP,
    hide: true,
    accessible: () => true, // Always accessible
  },
  {
    name: 'Company Signup',
    layout: '/auth',
    path: '/company-signup',
    icon: <Icon as={IoIosBusiness} width="16px" height="16px" color="inherit" />,
    component: CompanySignupWizard,
    hide: true,
    accessible: () => true, // Always accessible - unprotected route
  },
];

export const Logout = [
  {
    name: 'התנתק',
    layout: '/auth',
    path: '/sign-out',
    icon: <Icon as={MdLogout} width="16px" height="16px" color="inherit" />,
    component: SignIn,
  },
];

export default routes;
